<template>
  <el-upload action="" drag :before-upload="beforeUpload" :http-request="uploadAction" :show-file-list="false">
    <i class="el-icon-upload" />
    <div class="el-upload__text">拖拉文件到此<em>或者點擊上傳</em></div>
    <div slot="tip" class="el-upload__tip">支援EXCEL檔及CSV檔 不超過1MB</div>
    <div class="filename">{{ filename }}</div>
  </el-upload>
</template>
<script>
const methods = {
  beforeUpload(file) {
    const isLt1M = file.size / 1024 / 1024 < 1;

    if (isLt1M) {
      return true;
    }

    this.$message({
      message: 'Please do not upload files larger than 1m in size.',
      type: 'warning',
    });
    return false;
  },
};
export default {
  props: ['uploadAction'],
  data() {
    return {
      filename: '',
    };
  },
  methods,
};
</script>
